import { Component, OnInit } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection} from '@angular/fire/firestore';
import {Observable}from 'rxjs/Observable';
import 'rxjs/add/operator/map';
declare const swal: any;
declare var $: any;
interface partner{
  name:string;
  id:any;
  createdAt?:string;
}
@Component({
  selector: 'app-partners-list',
  templateUrl: './partners-list.component.html',
  styleUrls: ['./partners-list.component.css']
})

export class PartnersListComponent implements OnInit {
  partnerscol:AngularFirestoreCollection<partner>;
 partners:Observable<partner[]>;
  id:any;
  constructor(private afs:AngularFirestore) { }

  ngOnInit() {
    this. partnerscol=this.afs.collection("partners",res =>{
      return res.orderBy('createdAt', 'desc')
    });
    this.partners=this. partnerscol.valueChanges();
  }

  delete(id) {
    console.log(id);
    this.id = id;
    $("#DeleteModal").modal();
  }
  deletedata() {
    $('#DeleteModal').modal('hide');
      this.afs.doc('/partners/'+this.id).delete().then(function () {  
        swal('Deleted!', 'Your List has been deleted.', 'success');
      }).catch(function(error){
        swal('Error!', error, 'error');
        console.error("error in removing document:",error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/Partnerss/partners-list/partners-list.component.ts